import * as Yup from "yup";
import { campo_obligatorio } from "../../utils/traductor";
import {
  getApellido,
  getemail,
  getTelefono,
  getavatar,
  getNombre,
} from "../../utils/variablesLocales";

export function initialValues() {
  return {
    nombre: getNombre(),
    apellido: getApellido(),
    email: getemail(),
    telefono: getTelefono(),
    avatar: getavatar().replace("uploads/", ""),
    fileAvatar: null,
  };
}

export function validationSchema() {
  return Yup.object({
    nombre: Yup.string().required(` ${campo_obligatorio} `),
    apellido: Yup.string().required(` ${campo_obligatorio} `),
    email: Yup.string().required(` ${campo_obligatorio} `),
  });
}
